import TableActionButtonEdit from './TableActionButtonEdit';

export default TableActionButtonEdit;
